// extracted by mini-css-extract-plugin
module.exports = {"verticalVideoWrapper":"VerticalVideo_verticalVideoWrapper__D6GWk","verticalVideoContainer":"VerticalVideo_verticalVideoContainer__i5PGN"};